import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    style: {
      '--pending-banners': _vm.pendingChangeBanners.length
    },
    attrs: {
      "fluid": ""
    }
  }, [_vm.pendingChangeBanners.length ? _c('div', {
    staticClass: "header-banners"
  }, _vm._l(_vm.pendingChangeBanners, function (banner) {
    return _c(VAlert, {
      key: banner,
      staticClass: "monitoring-info-banner mb-0",
      attrs: {
        "color": _vm.color,
        "outlined": "",
        "dense": "",
        "icon": "fal fa-info-circle"
      }
    }, [_vm._v("\n      " + _vm._s(banner) + "\n    ")]);
  }), 1) : _vm._e(), _c('core-header', {
    attrs: {
      "subtitle": _vm.connector.id && `ID: ${_vm.connector.id}`
    },
    scopedSlots: _vm._u([{
      key: "headline",
      fn: function () {
        return [_vm._v("\n      " + _vm._s(_vm.connector.name) + "\n      "), _vm.connectorStateBadge ? _c(VChip, {
          staticClass: "ml-3 white--text",
          attrs: {
            "color": _vm.connectorStateBadge.color,
            "small": "",
            "data-cy": "connector_state_badge"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.connectorStateBadge.text) + "\n      ")]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c(VSwitch, {
          staticStyle: {
            "display": "inline-block"
          },
          attrs: {
            "disabled": !_vm.canManageIntegrations,
            "color": _vm.color,
            "label": _vm.$i18n_t('Connectors.Connectors.enabledToggle')
          },
          model: {
            value: _vm.connector.active,
            callback: function ($$v) {
              _vm.$set(_vm.connector, "active", $$v);
            },
            expression: "connector.active"
          }
        }), _vm.canManageIntegrations ? _c('core-button', {
          attrs: {
            "disabled": !_vm.canSave,
            "color": _vm.color,
            "solid-icon": "",
            "prepend-icon": "fa-save",
            "data-cy": "validate_save_connector"
          },
          on: {
            "click": _vm.validateConnector
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.save')) + "\n      ")]) : _vm._e(), _c('core-button', {
          attrs: {
            "color": "danger",
            "prepend-icon": "fa-times"
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push('/connectors/list');
            }
          }
        })];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c(VTabs, {
    attrs: {
      "show-arrows": ""
    },
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-metadata"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Connectors.Connectors.tabs.metaData')) + "\n          ")]), _c(VTab, {
    attrs: {
      "href": "#tab-connectiondata"
    }
  }, [_vm.hasConnectionDataError ? _c(VIcon, {
    staticClass: "mr-1",
    attrs: {
      "size": "large",
      "color": "danger"
    }
  }, [_vm._v("\n              fal fa-exclamation-triangle\n            ")]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.$i18n_t('Connectors.Connectors.tabs.connectionData')) + "\n          ")], 1), _vm.showConnectorLogs ? _c(VTab, {
    attrs: {
      "href": "#tab-connectorlogs",
      "data-cy": "tabConnectorLogs"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Connectors.Connectors.tabs.connectorLogs')) + "\n          ")]) : _vm._e(), _vm.canManageIntegrations ? _c(VTab, {
    attrs: {
      "href": "#tab-statuslogs"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Connectors.Connectors.tabs.statusLogs')) + "\n          ")]) : _vm._e(), _vm.showMonitoringControls ? _c(VTab, {
    attrs: {
      "href": "#tab-monitoring",
      "data-cy": "tabMonitoring"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.tabs.monitoring')) + "\n          ")]) : _vm._e(), _c(VTabsItems, {
    staticClass: "mb-8 pt-6",
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "tab-metadata",
    attrs: {
      "value": "tab-metadata"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "data-cy": "connector_name",
      "readonly": !_vm.canManageIntegrations,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.tenant.bridges.bridgeName'),
      "autocomplete": "off",
      "required": ""
    },
    model: {
      value: _vm.connector.name,
      callback: function ($$v) {
        _vm.$set(_vm.connector, "name", $$v);
      },
      expression: "connector.name"
    }
  }), _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "data-cy": "selected_account",
      "label": _vm.$i18n_t('accMgmt.system.tenantSelector'),
      "items": _vm.accounts,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "return-object": "",
      "required": "",
      "disabled": _vm.isEditMode
    },
    model: {
      value: _vm.selectedAccount,
      callback: function ($$v) {
        _vm.selectedAccount = $$v;
      },
      expression: "selectedAccount"
    }
  })], 1), _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextarea, {
    attrs: {
      "data-cy": "connector_description",
      "readonly": !_vm.canManageIntegrations,
      "color": _vm.color,
      "label": "Description",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "dense": ""
    },
    model: {
      value: _vm.connector.description,
      callback: function ($$v) {
        _vm.$set(_vm.connector, "description", $$v);
      },
      expression: "connector.description"
    }
  })], 1)], 1)], 1), _c(VTabItem, {
    key: "tab-connectiondata",
    attrs: {
      "value": "tab-connectiondata"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "4",
      "xl": "3"
    }
  }, [_c(VSelect, {
    staticClass: "required",
    attrs: {
      "data-cy": "connector_type",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.bridgeTypes,
      "label": _vm.$i18n_t('accMgmt.tenant.bridges.types'),
      "item-text": "name",
      "item-value": "type",
      "hide-details": "",
      "disabled": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function () {
        return [_vm.bridgeConfigIsInbound(_vm.bridgeTypes.filter(item => item.type === _vm.connector.type)[0]) ? _c(VIcon, {
          staticClass: "mr-1",
          attrs: {
            "size": "14"
          }
        }, [_vm._v("\n                        fal fa-arrow-down\n                      ")]) : _vm._e(), _vm.bridgeConfigIsOutbound(_vm.bridgeTypes.filter(item => item.type === _vm.connector.type)[0]) ? _c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "size": "14"
          }
        }, [_vm._v("\n                        fal fa-arrow-up\n                      ")]) : _vm._e(), _vm._v("\n                      " + _vm._s(_vm.bridgeTypes.filter(item => item.type === _vm.connector.type)[0].name) + "\n                    ")];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (data) {
        return [_c(VListItemAvatar, [_vm.bridgeConfigIsInbound(data.item) ? [_c(VIcon, {
          staticClass: "mr-0",
          attrs: {
            "size": "14"
          }
        }, [_vm._v("fal fa-arrow-down")])] : _vm._e(), _vm.bridgeConfigIsOutbound(data.item) ? [_c(VIcon, {
          staticClass: "mr-0",
          attrs: {
            "size": "14"
          }
        }, [_vm._v("fal fa-arrow-up")])] : _vm._e()], 2), _c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        })], 1)];
      }
    }]),
    model: {
      value: _vm.connector.type,
      callback: function ($$v) {
        _vm.$set(_vm.connector, "type", $$v);
      },
      expression: "connector.type"
    }
  })], 1)], 1), _vm.connector.type ? [_c(VRow, {
    staticClass: "py-2",
    staticStyle: {
      "min-width": "0"
    }
  }, [_vm.connector.type === 'bridge-incomingwebhook' ? _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('custom-text-field-clipboard', {
    staticClass: "py-4",
    attrs: {
      "data-cy": "api_url",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "label": _vm.$i18n_t('Connectors.Connectors.apiEndpoint')
    },
    model: {
      value: _vm.apiUrl,
      callback: function ($$v) {
        _vm.apiUrl = $$v;
      },
      expression: "apiUrl"
    }
  })], 1) : _vm._e(), _vm.connector.type === 'bridge-chirpstack' ? _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('custom-text-field-clipboard', {
    staticClass: "py-4",
    attrs: {
      "data-cy": "api_url_chirpstack",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "label": _vm.$i18n_t('Connectors.Connectors.apiEndpoint')
    },
    model: {
      value: _vm.apiUrlChirpstack,
      callback: function ($$v) {
        _vm.apiUrlChirpstack = $$v;
      },
      expression: "apiUrlChirpstack"
    }
  })], 1) : _vm._e(), _vm.connector.type === 'bridge-lwm2m-server' ? _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('custom-text-field-clipboard', {
    staticClass: "py-4",
    attrs: {
      "data-cy": "api_url_lwm2m_server",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "label": _vm.$i18n_t('Connectors.Connectors.apiEndpoint')
    },
    model: {
      value: _vm.apiUrlLwM2M,
      callback: function ($$v) {
        _vm.apiUrlLwM2M = $$v;
      },
      expression: "apiUrlLwM2M"
    }
  })], 1) : _vm._e(), _vm._l(_vm.bridgeConfigKeys(_vm.connector), function (configKey, j) {
    return _c(VCol, {
      key: `bridge_config_item_${j}`,
      staticClass: "py-4",
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": _vm.getColumnSize('md', configKey, _vm.bridgeConfig(_vm.connector).manifest),
        "lg": _vm.getColumnSize('lg', configKey, _vm.bridgeConfig(_vm.connector).manifest),
        "xl": _vm.getColumnSize('xl', configKey, _vm.bridgeConfig(_vm.connector).manifest)
      }
    }, [_c('core-tenant-bridge-config-field', {
      attrs: {
        "data-cy": "connector_bridge_config",
        "fieldConfig": _vm.bridgeConfig(_vm.connector).manifest.config[0][configKey],
        "bridgeConfig": _vm.connector.bridge.config,
        "bridgeConfigId": _vm.connector.id,
        "bridgeType": _vm.connector.type,
        "configKey": configKey,
        "bridgeManifest": _vm.bridgeConfig(_vm.connector).manifest,
        "bridgeHasValidParameters": _vm.bridgeHasValidParameters(),
        "bridgeHasValidParametersStrict": _vm.bridgeHasValidParameters(true),
        "brigdeHasError": _vm.connector.hasError,
        "disabled": !_vm.canManageIntegrations
      },
      on: {
        "changedBridgeParams": _vm.changedBridgeParams
      },
      model: {
        value: _vm.connector.bridge.config[configKey],
        callback: function ($$v) {
          _vm.$set(_vm.connector.bridge.config, configKey, $$v);
        },
        expression: "connector.bridge.config[configKey]"
      }
    })], 1);
  }), _vm.shouldShowTemplateSelect(_vm.connector) ? _c(VCol, {
    staticClass: "py-4",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c(VSelect, {
    attrs: {
      "data-cy": "connector_config_parser_script",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "items": _vm.bridgeConfig(_vm.connector).manifest.templates,
      "label": _vm.$i18n_t('accMgmt.tenant.bridges.bridgeTemplate'),
      "disabled": _vm.connector.bridge.mutator !== undefined || _vm.bridgeConfig(_vm.connector).manifest.templates.length === 1,
      "readonly": !_vm.canManageIntegrations || _vm.connector.bridge.mutator !== undefined || _vm.bridgeConfig(_vm.connector).manifest.templates.length === 1,
      "item-text": "name",
      "item-value": "name",
      "hide-details": "auto",
      "required": ""
    },
    scopedSlots: _vm._u([_vm.canManageIntegrations && _vm.bridgeConfig(_vm.connector).manifest.functionScope.editableMutator ? {
      key: "append-outer",
      fn: function () {
        return [_c(VBtn, {
          class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
          attrs: {
            "color": _vm.color,
            "icon": "",
            "info": "",
            "fab": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.editConfigMutator(_vm.connector, _vm.i);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal fa-" + _vm._s(_vm.connector.bridge.mutator ? 'undo' : 'edit'))])], 1)];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.connector.config.parser.script,
      callback: function ($$v) {
        _vm.$set(_vm.connector.config.parser, "script", $$v);
      },
      expression: "connector.config.parser.script"
    }
  })], 1) : _vm._e(), _vm.connector.bridge.mutator ? _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-script-editor', {
    attrs: {
      "script": _vm.connector.bridge.mutator,
      "script-type": "javascript",
      "fixed-payload-type": "JSON",
      "hide-script-type-selector": "",
      "readonly": !_vm.canManageIntegrations
    },
    on: {
      "update:script": _vm.onMutatorScriptChange
    }
  })], 1) : _vm._e()], 2), _vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference ? _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": null
    }
  }, [_c(VExpansionPanel, {
    attrs: {
      "flat": ""
    }
  }, [_c(VExpansionPanelHeader, [_vm.$i18n_te(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.title`) ? _c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n                            " + _vm._s(_vm.$i18n_t(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.title`)) + "\n                          ")]) : _vm._e()]), _c(VExpansionPanelContent, [_vm.$i18n_te(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.text01`) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.text01`))
    }
  }), _c('br')]) : _vm._e(), _vm.$i18n_te(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.text02`) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.text02`))
    }
  }), _c('br')]) : _vm._e(), _vm.$i18n_te(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.text03`) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.text03`))
    }
  })]) : _vm._e()])], 1)], 1)], 1)], 1) : _vm._e()] : _vm._e()], 2), _vm.showConnectorLogs ? _c(VTabItem, {
    key: "tab-connectorlogs",
    attrs: {
      "value": "tab-connectorlogs"
    }
  }, [_c('core-connectors-packet-logs', {
    ref: "packetLogs",
    attrs: {
      "connectorId": _vm.connector.id
    }
  })], 1) : _vm._e(), _vm.canManageIntegrations ? _c(VTabItem, {
    key: "tab-statuslogs",
    attrs: {
      "value": "tab-statuslogs"
    }
  }, [_c('core-connectors-status-logs', {
    ref: "statusLogs",
    attrs: {
      "connectorId": _vm.connector.id
    }
  })], 1) : _vm._e(), _vm.showMonitoringControls ? _c(VTabItem, {
    key: "tab-monitoring",
    attrs: {
      "value": "tab-monitoring"
    }
  }, [_vm.connector && _vm.connector.id && _vm.monitoringConfig && _vm.selectedAccount ? _c('core-connectors-bridge-monitoring', {
    attrs: {
      "bridge-id": _vm.connector.id,
      "tenant-id": _vm.selectedAccount.id,
      "monitoring-config": _vm.monitoringConfig
    },
    on: {
      "config-changed": _vm.fetchMonitoringConfig,
      "start-monitoring": function ($event) {
        _vm.monitoringEnableDialog = true;
      },
      "pause-monitoring": _vm.openMonitoringPauseDialog,
      "stop-delete-monitoring": _vm.openMonitoringStopDeleteDialog
    }
  }) : _c('core-empty-state', {
    attrs: {
      "icon": "fa-chart-line",
      "color": _vm.color,
      "title": _vm.$i18n_t('Connectors.Monitoring.disabled.title')
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function () {
        return [_c('core-button', {
          staticClass: "mt-4",
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-play",
            "data-cy": "start_monitoring"
          },
          on: {
            "click": function ($event) {
              _vm.monitoringEnableDialog = true;
            }
          }
        }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.enableButton')) + "\n                  ")])];
      },
      proxy: true
    }], null, false, 394612020)
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.disabled.description')))])])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm.showMonitoringControls ? _c('monitoring-enable-dialog', {
    attrs: {
      "open": _vm.monitoringEnableDialog,
      "config": _vm.monitoringConfig
    },
    on: {
      "close": function ($event) {
        _vm.monitoringEnableDialog = false;
      },
      "confirm": _vm.handleMonitoringEnableConfirm
    }
  }) : _vm._e(), _vm.showMonitoringControls ? _c('monitoring-disable-dialog', {
    attrs: {
      "open": _vm.monitoringDisableDialog,
      "mode": _vm.monitoringDisableMode
    },
    on: {
      "close": function ($event) {
        _vm.monitoringDisableDialog = false;
      },
      "confirm": _vm.handleMonitoringDisableConfirm
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };